import React from 'react';
import styles from './ProposalShape.module.css';
import { buildShapeStyle } from '../shapeStyleUtils';

const ProposalShape = ({
  id,
  shape = 'rectangle',
  color = 'rgba(0,0,0,1)',
  width = 120,
  height = 40,
  alignment = 'left',
  rotation = 0,
  borderColor = null,
  borderWidth = 0,
}) => {
  const justify = alignment === 'center'
    ? 'center'
    : (alignment === 'end' || alignment === 'right' ? 'flex-end' : 'flex-start');

  return (
    <div id={id} className={styles.wrapper} style={{ justifyContent: justify }}>
      <div
        className={styles.shape}
        style={{
          width,
          height,
          ...buildShapeStyle({
            shape,
            color,
            borderColor,
            borderWidth,
            rotation,
            width,
            height,
          }),
        }}
      />
    </div>
  );
};

export default ProposalShape;
